import React from "react";
import { Link } from "react-router-dom";

// Orders Data
const shipments = {
  columns: [
    {
      Header: "DETAILS",
      accessor: "details",
      Cell: ({value}) => (<Link to={`/shipper/${value}`}><button>Details</button></Link>),
      sortable: false,
      filterable: false
    },
    {
      Header: "SHIPPER ID",
      accessor: "id"
    },
    {
      Header: "SHIPPER NAME",
      accessor: "name"
    }
  ],
  dataRows: [
    ["1", "1", "Load to Ride Transportation"],
    ["2", "2", "Open Road Transportation"],
    ["3", "3", "Knight Transportation"],
    ["4", "4", "Arcbest"],
    ["5", "5", "XPO Logistics"]
  ],
  markers: [
    { latLng: [37.47, -122.25], name: "San Francisco" },
    { latLng: [35.06, -106.36], name: "Albequerque, NM" },
    { latLng: [29.60, -95.62], name: "Sugar Land, TX" },
    { latLng: [35.99, -78.90], name: "Durham, NC" },
    { latLng: [40.76, -73.97], name: "New York, NY" },
    { latLng: [34.08, -118.24], name: "Los Angeles, CA" },
    { latLng: [41.85, -87.64], name: "Chicago, IL" },
    { latLng: [29.77, -95.36], name: "Houston, TX" },
    { latLng: [33.46, -112.07], name: "Phoenix, AZ" },
    { latLng: [39.96, -75.15], name: "Philadelphia, PA" },
    { latLng: [29.40, -98.49], name: "San Antonio, TX" },
    { latLng: [25.77, -80.19], name: "Miami, FL" },
    { latLng: [39.75, -104.98], name: "Denver, CO" },
    { latLng: [47.60, -122.32], name: "Seattle, WA" }
  ],
  dataLoaded: false
};

const initState = {
  shipments,
}

export default (state = initState, action) => {
  switch (action.type) {
    case 'SET_SHIPPERS':
      console.log('SET_SHIPPERS')
      return {
        ...state,
        shippers: {
          ...state.shippers,
          dataRows: action.dataRows,
          expandedData: action.expandedData,
          dataLoaded: true
        }
      };   
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/shippersReducer.jsx